<!-- 停检通知单 -->
<template>
  <h-inspection-page :title="h_i18n('0addf9d81daedc6979addd92d00e46c1')+data.title" :ction-update="changeMethod" class="rejectsStop_reportTable_style">
    <form-header :title="h_i18n('e3e417b412a4ee1bcd18070935d3cb70')" title-height="80px" class="top_wrap_style" title-width="5">
      <template #title>
        <h-p align="left" :title="h_i18n('f3737dbfae61193590bd513df85ff250')" class="source_style source_style_1" style="line-height:32px;">{{ getData.sourceId }}</h-p>
        <h-p align="left" :title="h_i18n('0d53faf6a8f9e2b4dcb1c4a47b5931cf')" class="source_style" style="line-height:32px;">{{ getData.isrtDate }}</h-p>
        <h-p align="left" :title="h_i18n('d0c804ab7560a31bd529bfeaf8a3a822')" class="source_style" style="line-height:32px;border-top:1px solid #ccc;">{{ getData.stopCheckId }}</h-p>
      </template>
      <template #body>
      </template>
    </form-header>

    <div class="top_style">
      <div class="ground_style">
        <div class="top_left">
          <table class="table-box-bordered" cellspacing="0">
            <colgroup class="top_left_table_title"></colgroup>
            <colgroup class="top_left_table_content"></colgroup>
            <colgroup class="top_left_table_title"></colgroup>
            <colgroup class="top_left_table_content"></colgroup>
            <tr>
              <td>{{ h_i18n('f1edca9f040d256cee01ef89fa5499f0') }}</td>
              <td>{{getData.mtlNo}}</td>
              <td>{{ h_i18n('901fcadda8a5683e7a83a0c811ff4382') }}</td>
              <td class="line-td-style">{{getData.mtlName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('1b7ecd2bdbd8a1a112dead57724f06df') }}</td>
              <td>{{getData.supplyCode}}</td>
              <td>{{ h_i18n('9190cc22c9ba377113bc54ac51013a0b') }}</td>
              <td class="line-td-style">{{getData.supplyName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('f218d8e773a5c9bdf6d7f6f3f67c8480') }}</td>
              <td>{{getData.stopReason}}</td>
              <td>{{ h_i18n('cbdba878d17090b8feae391f103e1ad2') }}</td>
              <td>{{getData.questionTypeName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('ac63d506cf4dce4b8b201170b8ccbe4d') }}</td>
              <!-- <td>{{getData.closeName}}</td> -->
              <td>*</td>
              <td>{{ h_i18n('c0de82e6d2c3df1b0fbc6a7ebece0c8b') }}</td>
              <td v-if="getData.isrtEmpName && (getData.isrtEmpName === h_i18n('eb75c9704c8438348aefb0932dd6fe12') || getData.isrtEmpName.toLowerCase() === 'system')">{{ getData.isrtEmpName }}</td>
              <td v-else>*</td>
              <!-- <td>{{getData.isrtEmpName}}</td> -->
            </tr>
            <tr>
              <td>{{ h_i18n('55ebf36b676c9893d645d6447fe97824') }}</td>
              <td>{{getData.isrtDate}}</td>
              <td>{{ h_i18n('69eebddeb52a7e749f41b3259e313f3f') }}</td>
              <td>{{ time(getData.stopCheckTime) }}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('03490f3868798323211aa633194df2c1') }}</td>
              <td class="line-td-style">{{getData.sybName}}</td>
              <td>{{ h_i18n('21fcf3e1a68d074169f73dcebdf31c55') }}</td>
              <td class="line-td-style">{{ time(getData.requireCompleteDate) }}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('2432b57515b3627faddccb1dd1df206e') }}</td>
              <td class="line-td-style">{{getData.remark}}</td>
              <td>{{ h_i18n('9bf0a8746b56b471e5171610dcb512fd') }}</td>
              <td class="line-td-style2" v-if="getData.questionTypeName === h_i18n('e33a85b78c79888a2abddf47e51685fb')">{{ h_i18n('a5141424bf5f347c34af071f86e105f2') }}</td>
              <td class="line-td-style2" v-else>{{ h_i18n('cba5ea450ff9504a55853e7f6c6eeeb4') }}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('a387575fefbbdf1383cc1ca6a57d2b00') }}</td>
              <td class="line-td-style" colspan="3">
                <h-file v-if="getData.badPictureUuid" :name="getData.badPicture"
                  :url="getData.badPictureUuid" :delete-type="false">
                </h-file>
              </td>
            </tr>
          </table>
        </div>
        <div class="top_right">
          <div class="topright_table" v-if="getData.questionTypeName === h_i18n('e33a85b78c79888a2abddf47e51685fb')">
            <el-table :data="getData.rectifyListData" border style="width: 100%;" height="392"
               :header-cell-style="()=>'background:#F1F2F8;padding: 8px 0;'">
              <el-table-column prop="ppmMin" :label="h_i18n('bdab0ed517165ad8afce629632313a57')" width=""></el-table-column>
              <el-table-column prop="yBlCnt" :label="h_i18n('f6f3d1ed8f90006c1180a3dfca10928a')" width=""></el-table-column>
              <el-table-column prop="yGhCnt" :label="h_i18n('8d6f6532e39e34a28881c293e15bc937')" min-width="80"></el-table-column>
              <el-table-column prop="yPpm" :label="h_i18n('2371f6af1a8666a36f746d0dfcc132d2')" min-width="80"></el-table-column>
            </el-table>
          </div>
          <div class="topright_table" v-else>
            <el-table :data="getData.rectifyListData" border style="width: 100%" height="392"
               :header-cell-style="()=>'background:rgb(232, 243, 255);padding: 8px 0;'">
              <el-table-column prop="rejectsId" :label="h_i18n('96ad1b86c31e8f1965a3fdafae75975d')" width=""></el-table-column>
              <el-table-column prop="flawMark" :label="h_i18n('0e73c6d4d0fd0664717ad4d66f98aba6')" width=""></el-table-column>
              <el-table-column prop="number" :label="h_i18n('0bf60b32f9db93b87e08763b1c815469')" width="80"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <slot name="auditContent"></slot>
    <slot name="btn"></slot>
  </h-inspection-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import { useRoute } from "vue-router";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submit','auditBtn','tabChange']
  )
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
      // sqm详情: detail Hmqm详情: particulars Hmqm闭环: close Hmqm闭环审核: auditClose HMQM停检恢复: recovery hmqm停检复查: checkAgin
    },
    getData: {
      type:Object,
      default: {}
    },
  })
  const data = reactive({
    title:'',
  })

  onMounted(()=>{
    props.kindType == 'detail' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
    props.kindType == 'particulars' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
    props.kindType == 'close' && (data.title = h_i18n('cea0671a77281d4923d26111191e4fd8'))
    props.kindType == 'auditClose' && (data.title = h_i18n('bc50786c52f189359fcbd4b193c1a3aa'))
    props.kindType == 'recovery' && (data.title = h_i18n('c7db6d4f1a42987a0df962e927926f14'))
    props.kindType == 'checkAgin' && (data.title = h_i18n('1235ea8893e90b8e0d74b6004fbbdb6c'))
    props.kindType == 'sqmAudit' && (data.title = h_i18n('59c1d28ffbf075894cb2684f702476c5'))
  })
</script>

<style lang="scss" scoped>
.rejectsStop_reportTable_style{
  .top_wrap_style{
    padding: 0;
  }
  .top_wrap_style > div{
    padding-left: 0px !important;
    padding-right: 0px !important;
    .haier-table{
      .haier-table-header{
        tr{
          td{
            .haier-table-header--right{
              margin-left: -1px;
              padding-left: 0px !important;
            }
          }
        }
      }
    }
  }
  .top_style{
    height: 100%;
    width: 100%;
    background: #fff;
    margin-top: 10px;
    .ground_style{
      display: flex;
      background: #f7f8fa;
      width: 100%;
      height: 100%;
      .top_left{
        color: #4E5969;
        font-size: 14px;
        width: 60%;
        background: #fff;
        border-radius: 8px;
        height: 100%;
        padding: 10px;
        .table-box-bordered{
          width: 100%;
          table-layout:fixed;
          font-size: 14px;
          border-left: 1px solid #ccc;
          border-top: 1px solid #ccc;
          background: #fff;
          .top_left_table_title{
            // background: #E8F3FF;
            width: 16%;
          }
          .top_left_table_content{
            width: 34%;
          }
          tr{
            td:nth-child(even){
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            td:nth-child(even):hover{
              white-space: unset;
              word-break: break-all;
              div{
                div{
                  white-space: unset;
                  word-break: break-all;
                }
              }
            }
            td:nth-child(odd){
              text-align: right;
            }
            td:nth-child(odd)::after{
              content: ':';
            }
          .line-td-style{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .line-td-style:hover{
            white-space: unset;
            word-break: break-all;
            div{
              div{
                white-space: unset;
                word-break: break-all;
              }
            }
          }
          .line-td-style2{
            white-space:normal !important;
          }
        }
        }
        // 左侧 table 样式
        .table-bordered ,.table-bordered table, .table-bordered th,.table-bordered td{
          border: 1px solid #ccc;
        }
        .table-box-bordered th{
          border-right: 1px solid #ccc;
          border-bottom:1px solid #ccc ;
        }
        .table-box-bordered td{
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          height: 48px;
          padding: 0 10px;
        }
        .table-box-bordered {
          .title_style{
            text-align: center;
            background: rgb(232, 243, 255);
          }
          .td_wh{
            padding: 5px 10px !important;
            .el-textarea{
              font-size: 14px;
              .el-textarea__inner{
                height: 100% !important;
              }
            }
          }
          .notMold_style{
            padding: 5px 10px !important;
            .el-textarea{
              font-size: 14px;
            .el-textarea__inner{
              height: 100% !important;
            }
          }
          }
        }
      }
      .top_right{
        margin-left: 10px ;
        width: 40%;
        background: #fff;
        border-radius: 8px;
        padding: 0 10px;
        // height: 100%;
        display: flex;
        .topright_table{
          width: 100%;
          height: 100%;
          padding: 10px 0;
          .haier-inspection-page .el-table th{
            background: rgb(232, 243, 255);
          }
          .el-table{
            border-bottom: 0px !important;
            border-right: 0px !important;
          }
        }
        .topright_pic{
          padding-left: 10px;
          padding-top: 10px;
          width: 31%;
          height: 100%;
        }
      }
    }
  }
}
</style>

<style lang=scss>
.rejectsStop_reportTable_style{
  .source_style_1{
    border-bottom: 1px solid #ccc;
  }
  .source_style{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block !important;
      width: 100%;
    }
    .source_style:hover{
      white-space: unset;
      word-break: break-all;
    }
}
</style>